import "../css/style.css"

// Our modules / classes
import Search from "./modules/Search"

// Instantiate a new object using our modules/classes
const search = new Search()
